
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import pausar from './resumen-menu-procesos-pausar.vue';
    import activar from './resumen-menu-procesos-activar.vue';
    import cerrar from './resumen-menu-procesos-cerrar.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            pausar,
            activar,
            cerrar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }
    }
